import { SET_BULK_UPLOAD, CLEAR_PARAMS_UPLOAD, SET_PARAMS_UPLOAD } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    dsp: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_UPLOAD:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_UPLOAD:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_UPLOAD:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
